/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ShopOrderRequest {
  allowDuplicity?: boolean;
  cpf?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  eans?: string;
  editionName?: string;
  email?: string;
  errorMessage?: string;
  glamId?: string;
  nfse?: string;
  personId?: number;
  personName?: string;
  shippingCompanyName?: string;
  shippingOrderRequestId?: number;
  shopOrderIdOriginal?: string;
  shopOrderIdResend?: string;
  status?: ShopOrderRequest.StatusEnum;
  subscriberEditionId?: number;
  ticketDetail?: string;
  ticketId?: number;
  ticketOrigin?: string;
  ticketSubject?: string;
  ticketTratativaDelivery?: string;
  ticketTratativaPortfolio?: string;
}
export namespace ShopOrderRequest {
  export type StatusEnum =
    | 'PENDENTE'
    | 'CRIADO'
    | 'ERRO'
    | 'CANCELADO'
    | 'PERSISTIDO';
  export const StatusEnum = {
    PENDENTE: 'PENDENTE' as StatusEnum,
    CRIADO: 'CRIADO' as StatusEnum,
    ERRO: 'ERRO' as StatusEnum,
    CANCELADO: 'CANCELADO' as StatusEnum,
    PERSISTIDO: 'PERSISTIDO' as StatusEnum
  };
}
